import { render, staticRenderFns } from "./FpStatistics.vue?vue&type=template&id=0dc05fc3&scoped=true&"
import script from "./FpStatistics.vue?vue&type=script&lang=js&"
export * from "./FpStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc05fc3",
  null
  
)

export default component.exports